import { get, writable } from "svelte/store"

export const currentDictionary = writable()

export const getCurrentDictionary = () => {
    return get(currentDictionary)
}